import CantonActions from './Actions'
import { Chip } from '@mui/material'

export const getColumns = (onEdit, onDelete, onRefresh) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', width: 70 },
  {
    field: 'name',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
  },
  {
    field: 'slug',
    headerName: 'Slug',
    headerAlign: 'center',
    flex: 1.5,
    minWidth: 120,
  },
  {
    field: 'center',
    headerName: 'Centro (Lng, Lat)',
    headerAlign: 'center',
    flex: 2,
    minWidth: 180,
    valueGetter: params => {
      const center = params.row.center
      if (center && Array.isArray(center)) {
        return `${center[0]?.toFixed(4)}, ${center[1]?.toFixed(4)}`
      }
      return '-'
    },
  },
  {
    field: 'zoom',
    headerName: 'Zoom',
    headerAlign: 'center',
    flex: 0.8,
    minWidth: 70,
    type: 'number',
  },
  {
    field: 'hasGeojson',
    headerName: 'GeoJSON',
    headerAlign: 'center',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Cargado' : 'Pendiente'}
        color={params.value ? 'info' : 'warning'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'enabled',
    headerAlign: 'center',
    headerName: 'Estado',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Activo' : 'Inactivo'}
        color={params.value ? 'success' : 'default'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => (
      <CantonActions {...{ params, onEdit, onDelete, onRefresh }} />
    ),
    minWidth: 150,
    flex: 1.5,
  },
]
